module.exports = __webpack_public_path__ + "static/media/groceryListIcon5.b1de5cdf.svg";